import React from 'react';
import './SectionHeadings.css';
import { ReactComponent as CustomerSvg } from '../../assets/icons/customer.svg';
import { ReactComponent as ProductSvg } from '../../assets/icons/product.svg';
import { ReactComponent as LeaderSvg } from '../../assets/icons/leader.svg';
import { ReactComponent as ProspectingSvg } from '../../assets/icons/prospecting.svg';
import { ReactComponent as AccountManagementSvg } from '../../assets/icons/accountManagement.svg';
import { ReactComponent as SalesToolsSvg } from '../../assets/icons/salesTools.svg';
import { trackRoleFilter } from '../../services/analyticsService';

interface SectionHeadingsProps {
  selectedRole: string | null;
  onRoleSelect: (role: string | null) => void;
  onResetFilters: () => void;
}

const SectionHeadings: React.FC<SectionHeadingsProps> = ({ selectedRole, onRoleSelect, onResetFilters }) => {
  const handleSubHeadingClick = (role: string) => {
    const nextRole = selectedRole === role ? null : role;
    if (nextRole) {
      console.log('[GA4 Debug] Role filter selected:', nextRole);
      trackRoleFilter(nextRole);
    }
    onRoleSelect(nextRole);
  };

  return (
    <div className="section-headings">
      <h3 className="section-heading">Role Based Filters</h3>
      <h4 
        className={`sub-heading ${selectedRole === 'Account Management' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Account Management')}
        title="Account Management"
      >
        <AccountManagementSvg className="sub-heading-icon" />
        <span>Account Management</span>
      </h4>
      <h4 
        className={`sub-heading ${selectedRole === 'Customer Success' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Customer Success')}
        title="Customer Success"
      >
        <CustomerSvg className="sub-heading-icon" />
        <span>Customer Success</span>
      </h4>
      <h4 
        className={`sub-heading ${selectedRole === 'Product' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Product')}
        title="Product"
      >
        <ProductSvg className="sub-heading-icon" />
        <span>Product</span>
      </h4>
      <h4 
        className={`sub-heading ${selectedRole === 'Prospecting' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Prospecting')}
        title="Prospecting"
      >
        <ProspectingSvg className="sub-heading-icon" />
        <span>Prospecting</span>
      </h4>
      <h4 
        className={`sub-heading ${selectedRole === 'Revenue Leaders' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Revenue Leaders')}
        title="Revenue Leaders"
      >
        <LeaderSvg className="sub-heading-icon" />
        <span>Revenue Leaders</span>
      </h4>
      <h4 
        className={`sub-heading ${selectedRole === 'Sales Specialist' ? 'selected' : ''}`}
        onClick={() => handleSubHeadingClick('Sales Specialist')}
        title="Sales Specialist"
      >
        <SalesToolsSvg className="sub-heading-icon" />
        <span>Sales Specialist</span>
      </h4>
      {selectedRole && (
        <button 
          className="reset-filters-btn"
          onClick={onResetFilters}
        >
          Reset Filters
        </button>
      )}
    </div>
  );
};

export default SectionHeadings;